import React, { createContext, useContext, useEffect, useState } from "react"
import {
  GetCharityCategories,
  GetFullCharityList,
  GetGeneralGlobalData,
  GetGiftCardRetailers
} from "../Code/Data"

const AppDataContext = createContext()

export const AppDataProvider = ({ children }) => {
  const [loading, setLoading] = useState(true)
  const [appData, setAppData] = useState()
  const [fullCharityList, setFullCharityList] = useState([])
  const [charityCategories, setCharityCategories] = useState([])
  const [retailersList, setRetailersList] = useState([])

  useEffect(() => {
    async function getAppData() {
      setLoading(true)
      try {
        const promises = [];
        if (!appData) {
          promises.push(
            GetGeneralGlobalData()
              .then(res => {
                if (res && res.Succeeded) {
                  const { Succeeded, ...data } = res;
                  setAppData(data);
                }
              })
              .catch(e => console.error("Error loading global data", e))
          );
        }
        if (!fullCharityList || !fullCharityList?.length) {
          try {
            const fromStorage = JSON.parse(localStorage?.getItem("charityList"))
            if (fromStorage && fromStorage.list && fromStorage.list.length > 99) {
               setFullCharityList(fromStorage.list)
            }
          } catch (e) {}
          promises.push(
            GetFullCharityList()
              .then(list => setFullCharityList(list))
              .catch(e => console.error("Error loading charity list", e))
          );
        }
        if (!charityCategories || !charityCategories?.length) {
          promises.push(
            GetCharityCategories()
              .then(cats => setCharityCategories(cats))
              .catch(e => console.error("Error loading categories", e))
          );
        }
        await Promise.all(promises);
      } catch (error) {
        console.error("Error loading app data", error)
      } finally {
        setLoading(false)
      }
    }

    getAppData()
  }, [])

  const getRetailersList = async () => {
    if (!!retailersList && retailersList?.length) {
      return retailersList
    }
    const retailers = await GetGiftCardRetailers()
    setRetailersList(retailers || []);
    return retailers;
  }

  return (
    <AppDataContext.Provider
      value={{
        loading,
        ...appData,
        fullCharityList,
        charityCategories,
        getRetailersList
      }}>
      {children}
    </AppDataContext.Provider>
  )
}

export const useAppData = () => useContext(AppDataContext)
